import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';

function PhoneCreate(props) {
  const { save, handleChangeinput, cancel } = props;
  return (
    <div>
      {
        <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
          <div className="columns mx-2 is-fullwidth">
            <div className="column is-5 is-offset-2 field">
              <label className="label">Número de telefone:
                <div className="control">
                  <input className="input mt-1" name="numberphone" id="numberphone" type="text" onChange={(e) => handleChangeinput(e.target)} placeholder="Apenas números"/>
                  <p name="numberphone-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-3 mt-2 field">
                <div className="control">
                  <button className="button is-info is-3 mx-2 px-5 is-small" type="submit" onClick={ () => save() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faSave } fixedWidth />
                    </span>
                    <span>
                      Salvar
                    </span>
                  </button>
                </div>
                <div className="control">
                  <button className="button is-warning is-multiline is-3 mt-2 mx-2 px-4 is-small" type="submit" onClick={ () => cancel() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faArrowAltCircleLeft } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
                  </button>
                </div>
            </div>
          </div>
        </form>
      }
    </div>
  );
}

export default PhoneCreate;
